// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ifs-modal-buttons mymunters-button button {\n  padding: 0 1rem;\n}\n.ifs-modal-buttons mymunters-button.ml-auto {\n  margin-left: auto;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
